import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

export default function VerifyOtp() {
  const { t } = useTranslation("global");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);
  const [timeLeft, setTimeLeft] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("otpAllowed");
  }, []);

  useEffect(() => {
    if (timeLeft === 0) {
      setCanResend(true);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleResend = async () => {
    setTimeLeft(60);
    setCanResend(false);
    const userData = JSON.parse(localStorage.getItem("user"));
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: userData?.data?.user.email,
        }),
      });
  
      const result = await response.json();
  
      if (result.code === 200) {
        toast.success(t("otp2.sent_again"), { autoClose: 2000 });
      } else {
        alert(result.message || t("errors.something_went_wrong"));
      }
    } catch (error) {
      toast.error(t("errors.server_error"));
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const enteredOtp = otp.join("");
    const userData = JSON.parse(localStorage.getItem("user"));
  
    if (enteredOtp == userData?.data?.otp) {
      toast.success(t("otp2.verified_successfully"), {
        autoClose: 2000,
        onClose: () => {
          localStorage.setItem("otpAllowed", "true");
          navigate("/change-password");
        }
      });
    } else {
      toast.error(t("otp2.invalid"));
    }
  };
  
  return (
    <section style={{ backgroundColor: "#193C6E", minHeight: "100vh" }}>
      <ToastContainer />
      <div className="container h-100">
        <div className="row d-flex justify-content-center align-items-center min-vh-100">
          <div className="col-lg-6 col-md-12">
            <img src="assets/imgs/layer 2.png" width="100%" alt={t("otp2.image_alt")} />
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="card-singin p-4 shadow rounded-4">
              <div >
                <img src="assets/imgs/تميز copy 1.svg" alt="Taamayaz Logo" className="mb-3" />
                <h2 className="second-color ">{t("otp2.title")}</h2>
                <p className="paragraph-color ">
                  {t("otp2.description")}
                </p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="d-flex justify-content-center gap-2 mb-4">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      className="form-control text-center"
                      style={{
                        width: "45px",
                        height: "50px",
                        fontSize: "20px",
                        border: "2px solid #6c757d",
                        borderRadius: "8px",
                      }}
                      maxLength="1"
                      value={digit}
                      onChange={(e) => handleChange(index, e)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      ref={(el) => (inputRefs.current[index] = el)}
                    />
                  ))}
                </div>

                <button
                  type="submit"
                  style={{ backgroundColor: "#352E64", color: "#fff" }}
                  className="btn w-100 py-2 my-3"
                >
                  {t("otp2.continue")}
                </button>
              </form>

              <p style={{ color: "#352E64" }} className="text-center mt-3">
                {t("otp2.not_received")}{" "}
                {canResend ? (
                  <span
                    className="fw-bold"
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    onClick={handleResend}
                  >
                    {t("otp2.resend")}
                  </span>
                ) : (
                  <span className="fw-bold">
                    {t("otp2.wait")} {timeLeft}s
                  </span>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
